import { render, staticRenderFns } from "./insureRuleZh.vue?vue&type=template&id=5920e374&scoped=true"
import script from "./insureRuleZh.vue?vue&type=script&lang=js"
export * from "./insureRuleZh.vue?vue&type=script&lang=js"
import style0 from "./insureRuleZh.vue?vue&type=style&index=0&id=5920e374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5920e374",
  null
  
)

export default component.exports